// extracted by mini-css-extract-plugin
module.exports = {"customizePracticeFormModal":"style-module__customizePracticeFormModal___RWvrk","header":"style-module__header___3vNGJ","radioOption":"style-module__radioOption___g0uI_"};